import MenuItemMixin from '~/mixins/MenuItemMixin'
import Pill from '@theme/components/atom/Pill'
import SubCategoryBox from '~/themes/base/components/category/SubCategoryBox'

export default {
  extends: SubCategoryBox,
  mixins: [MenuItemMixin],
  components: { Pill },
}
